// "Comprar agora": leva direto ao checkout sem pular o carrinho.
//
// Por que não usar o botão de pagamento dinâmico da Shopify: ele manda o
// cliente ao pagamento por fora do carrinho, e com isso perde os campos de
// personalização — nome, arte, observações. Aqui o pedido passa pelo mesmo
// POST do "Adicionar ao carrinho", com a mesma validação, e só então salta
// para o checkout por meio do return_to.
document.addEventListener('click', (evento) => {
  const botao = evento.target.closest('[data-comprar-agora]');
  if (!botao) return;

  const form = botao.closest('form');
  if (!form) return;

  // O formulário do Dawn tem novalidate; sem isto o campo obrigatório passaria em branco.
  if (!form.reportValidity()) return;

  let destino = form.querySelector('input[name="return_to"]');
  if (!destino) {
    destino = document.createElement('input');
    destino.type = 'hidden';
    destino.name = 'return_to';
    form.appendChild(destino);
  }
  destino.value = '/checkout';

  botao.setAttribute('aria-busy', 'true');
  // submit() em vez de requestSubmit(): não dispara o handler do tema, que
  // interceptaria por AJAX — e a API AJAX não aceita o upload da arte.
  form.submit();
});
